import React from 'react';
import { IconContext } from '../../icon/icon-provider';

import type { PropsWithChildren } from 'react';
import type { IconProps } from '../..';

export type AlertTitleIconProviderProps = PropsWithChildren<IconProps>;

export function AlertTitleIconProvider(props: AlertTitleIconProviderProps) {
  const { children, ...otherProps } = props;

  const iconStyle = {
    height: '$size250',
    width: '$size250',
    flexShrink: 0,
  };

  const providerProps = { ...iconStyle, ...otherProps };
  return <IconContext.Provider value={providerProps}>{children}</IconContext.Provider>;
}
